import BackendApiClient from '../api/BackendApiClient';
import { IMap, LoginResponseInterface, OneTimePasswordInterface } from '../exports/Interfaces';
import { DataWrappedResponse, Response } from '../exports/Types';
import { AxiosRequestConfig } from 'axios';
import { AuthGrant, OTP_DELIVERY_CHANNELS } from '../exports/Constants';

export interface PostOptDataInterface {
  company_id: number;
  phone_number: string;
  lang?: string;
  delivery_channel?: OTP_DELIVERY_CHANNELS;
  /** Required by the backend when delivery_channel is EMAIL and the customer is new. */
  email?: string;
  country?: string;
}

export interface PostLoginDataInterface {
  company_id: number;
  phone_number: string;
  password: string;
}

export type OtpLoginData = {
  grant?: null | AuthGrant.OneTimePassword;
  company_id: number;
  phone_number: string;
  password: string;
  utm_source?: string;
};

export type LoginData =
  | {
      grant: AuthGrant.NhasUserToken;
      company_id: number;
      auth_token: string;
    }
  | OtpLoginData;

class AuthorizationManager {
  public postOptCode = async (
    data: PostOptDataInterface,
    headers?: IMap<string>,
  ): Promise<DataWrappedResponse<OneTimePasswordInterface>> =>
    BackendApiClient.request({
      method: 'POST',
      url: '/one-time-passwords',
      data,
      headers,
    });

  public postLogin = async (data: LoginData, config?: AxiosRequestConfig): Promise<Response<LoginResponseInterface>> =>
    BackendApiClient.request({
      method: 'POST',
      url: '/login',
      data,
      ...config,
    });

  public deleteAccount = async (config?: AxiosRequestConfig): Promise<Response<[]>> =>
    BackendApiClient.request({
      method: 'DELETE',
      url: '/account',
      ...config,
    });
}

export default new AuthorizationManager();
